import { render, staticRenderFns } from "./DepartmentUserWindow.vue?vue&type=template&id=34ff651e&scoped=true&"
import script from "./DepartmentUserWindow.vue?vue&type=script&lang=js&"
export * from "./DepartmentUserWindow.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentUserWindow.vue?vue&type=style&index=0&id=34ff651e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ff651e",
  null
  
)

export default component.exports